module.exports = __webpack_public_path__ + "static/media/3c611b98-8e5e-4813-b686-3e7417601af0.03923bb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/3c611b98-8e5e-4813-b686-3e7417601af0.svg
// module id = 77
// module chunks = 0